import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

document.addEventListener('DOMContentLoaded', () => {
  UIkit.use(Icons);
});
